import { render, staticRenderFns } from "./tags.vue?vue&type=template&id=52adeb09"
import script from "./tags.ts?vue&type=script&lang=ts&external"
export * from "./tags.ts?vue&type=script&lang=ts&external"
import style0 from "./tags.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52adeb09')) {
      api.createRecord('52adeb09', component.options)
    } else {
      api.reload('52adeb09', component.options)
    }
    module.hot.accept("./tags.vue?vue&type=template&id=52adeb09", function () {
      api.rerender('52adeb09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/focus-topics/tags/tags.vue"
export default component.exports